import { clsx } from 'clsx';

export default function ParchmentCard({ children, className, style, variant = 'default', onClick }) {
  const variants = {
    default: 'parchment-card',
    dark: 'rounded-2xl border border-edge bg-surfaceAlt text-fg shadow-game-card',
    gold: 'rounded-2xl border border-accent/40 bg-accent/10 text-fg',
  };

  return (
    <div className={clsx(variants[variant], 'p-4', className)} style={style} onClick={onClick}>
      {children}
    </div>
  );
}
